import React from 'react';
import { useEffect, useState, useRef } from 'react';


export function Adsense({ type }) {
    useEffect(() => {
        const pushAd = () => {
            try {
                const adsbygoogle = window.adsbygoogle
                // console.log({ adsbygoogle })
                adsbygoogle.push({})
            } catch (e) {
                console.error(e)
            }
        }

        let interval = setInterval(() => {
            // Check if Adsense script is loaded every 300ms
            if (window.adsbygoogle) {
                pushAd()
                // clear the interval once the ad is pushed so that function isn't called indefinitely
                clearInterval(interval)
            }
        }, 300)

        return () => {
            clearInterval(interval)
        }

    }, [])

    if (process.env.NODE_ENV !== "production")
        return (
            <div
                style={{
                    background: "#e9e9e9",
                    color: "black",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    height: "150px"
                }}
            >
                {type + ' ADSense'}
            </div>
        );

    if (type == 'dp')
        return (
            <ins
                className='adsbygoogle'
                style={{ display: 'block' }}
                data-ad-client="ca-pub-9037482225951531"
                data-ad-slot="8014590615"
                data-ad-format="auto"
                data-full-width-responsive="true"
            >
                {/* ADSense {type} */}
            </ins>
        )

    if (type == 'dpb')
        return (
            <ins
                className='adsbygoogle'
                style={{ display: 'inline-block', width: '300px', height: '100px' }}
                data-ad-client="ca-pub-9037482225951531"
                data-ad-slot="9238427976"
            >
                {/* ADSense {type} */}
            </ins>
        )

    if (type == 'if')
        return (
            <ins
                className='adsbygoogle'
                style={{ display: 'block' }}
                data-ad-client="ca-pub-9037482225951531"
                data-ad-slot="2910707242"
                data-ad-format="fluid"
                data-ad-layout-key="-7Þb+eo+0+2+1"
            >
                {/* ADSense {type} */}
            </ins>
        )

    if (type == 'ia')
        return (
            <ins
                className='adsbygoogle'
                style={{ display: 'block' }}
                data-ad-layout="in-article"
                data-ad-format="fluid"
                data-ad-client="ca-pub-9037482225951531"
                data-ad-slot="6144353860"
            >
                {/* ADSense {type} */}
            </ins>
        )
}

export function KakaoAdFit({ type, disabled }) {
    const scriptElementWrapper = useRef(null);

    let [ad, adSet] = useState({ unit: '', width: '', height: '' })

    useEffect(() => {

        if (type == 'banner') {
            ad.unit = 'DAN-8ImxtBwFIPpdNRqK';
            ad.width = '320';
            ad.height = '100';
        }
        if (type == 'slot') {
            ad.unit = 'DAN-uB8UiCp1L5PRXOxl';
            ad.width = '300';
            ad.height = '250';
        }

        if (!disabled) {
            const script = document.createElement("script");
            script.setAttribute("src", "https://t1.daumcdn.net/kas/static/ba.min.js");
            scriptElementWrapper.current.appendChild(script);

            return () => {
                const globalAdfit = window.adfit;
                if (globalAdfit) globalAdfit.destroy(ad.unit);
            }
        }
    }, [])



    return (
        <div ref={scriptElementWrapper}>

            {ad.unit != '' && (
                <ins className="kakao_ad_area" style={{ display: "none" }}
                    data-ad-unit={ad.unit}
                    data-ad-width={ad.width}
                    data-ad-height={ad.height}>
                </ins>
            )}

        </div>
    )
}

